var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center w-100"},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v(_vm._s(_vm.featureIcon))]),_c('mult-name',{staticClass:"effect-name",attrs:{"name":_vm.mult}}),_c('v-spacer'),_c('div',{staticClass:"effect-name ml-2"},[_vm._v(_vm._s(_vm.scalingIcon)+_vm._s(_vm.$formatNum(_vm.effectPower, true)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }